"use client"

import React, { useState, useEffect } from "react"
import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, AlertTriangle, Info, XCircle, Bell } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()
  const [duration, setDuration] = useState(3000)

  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth < 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      setDuration(isMobile ? 2000 : 3000)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const getIcon = (variant: string | null | undefined) => {
    const iconClass = "h-5 w-5 shrink-0"
    switch (variant) {
      case "success": return <CheckCircle2 className={iconClass} />
      case "destructive": return <XCircle className={iconClass} />
      case "warning": return <AlertTriangle className={iconClass} />
      case "info": return <Info className={iconClass} />
      case "secondary": return <Bell className={iconClass} />
      default: return null
    }
  }

  return (
    <ToastProvider duration={duration}>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex gap-3 items-start">
              {variant && variant !== 'default' && (
                <div className="mt-0.5 opacity-90">
                  {getIcon(variant)}
                </div>
              )}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
